import React from 'react';
import withUser from '../../../../lib/WithUser';
import withProperty from '../../WithProperty';
import MiscSearch from './MiscSearch';

const searchTypeId = 78;

const MiscSearch4 = (props: any) => {
  return <MiscSearch {...{ ...props, searchTypeId }} />;
};

export default withProperty(withUser(MiscSearch4), searchTypeId, true);
